import { Button, DatePicker } from "@rio-cloud/rio-uikit";

type HistoryItem = {
    id: string;
    user: string;
    dateTime: string;
    stage: string;
    previousValue: string;
    fieldChanged: string;
    newValue: string;
};

const SAMPLE_HISTORY: HistoryItem[] = [
    {
        id: '1',
        user: 'Marcio Pereira',
        dateTime: '10/10/2024 - 06:43',
        stage: 'Análise VWCO',
        previousValue:
            'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry\'s standard dummy text ever since the 1500s, when an',
        fieldChanged: 'Observações',
        newValue:
            'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry\'s standard dummy text ever since the 1500s, when an',
    },
    {
        id: '2',
        user: 'Marcio Pereira',
        dateTime: '10/10/2024 - 06:43',
        stage: 'Análise VWCO',
        previousValue:
            'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry\'s standard dummy text ever since the 1500s, when an',
        fieldChanged: 'Observações',
        newValue:
            'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry\'s standard dummy text ever since the 1500s, when an',
    },
    {
        id: '3',
        user: 'Marcio Pereira',
        dateTime: '10/10/2024 - 06:43',
        stage: 'Análise VWCO',
        previousValue:
            'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry\'s standard dummy text ever since the 1500s, when an',
        fieldChanged: 'Observações',
        newValue:
            'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry\'s standard dummy text ever since the 1500s, when an',
    },
];

export default function SupportHistoryPage() {
    const history = SAMPLE_HISTORY;

    return (
        <div className="mx-auto px-4 pb-10">
            <div className="mb-8">
                <form className="flex justify-start items-center flex-wrap gap-6">
                    <div className='form-group flex-1'>
                        <label className='text-size-12 text-color-darker'>
                            Etapa
                        </label>
                        <select
                            className='form-control'
                            value={''}
                            onChange={() => {}}
                        >
                            <option key={'teste'} value={'teste'}>
                                teste
                            </option>
                        </select>
                    </div>
                    <div className='form-group flex-1'>
                        <label className='text-size-12 text-color-darker'>
                            Usuário
                        </label>
                        <input
                            type='text'
                            className='form-control'
                            value={''}
                            onChange={() => {}}
                        />
                    </div>
                    <div className='form-group  w-full max-w-72'>
                        <label className='text-size-12 text-color-darker'>
                            Data de atualização
                        </label>
                        <DatePicker
                            id='tech'
                            inputProps={{ placeholder: 'Selecione' }}
                            dateFormat='DD/MM/YYYY'
                            timeFormat={false}
                            onChange={() => {}}
                            className="margin-0"
                        />
                    </div>
                    <p className="mt-3">Até</p>
                    <div className='form-group  w-full max-w-72'>
                        <label className='text-size-12 text-color-darker'>
                            Data de atualização
                        </label>
                        <DatePicker
                            id='tech'
                            inputProps={{ placeholder: 'Selecione' }}
                            dateFormat='DD/MM/YYYY'
                            timeFormat={false}
                            onChange={() => {}}
                            className="margin-0"
                        />
                    </div>
                    <Button className="btn btn-primary mt-4" type="submit">Aplicar filtro</Button>
                </form>
            </div>
            <div className="relative">
                <div className="absolute left-10 top-0 bottom-0 w-px border-l-2 border-dashed border-gray-200 pointer-events-none -z-0" />

                <div className="space-y-8">
                    {history.map((item) => (
                        <div key={item.id} className="relative flex items-start">
                            <div className="w-16 flex-shrink-0 flex justify-start z-10">
                                <div className="flex items-center justify-center w-10 h-10 bg-slate-100 rounded-full border border-gray-200 shadow-sm">
                                    <span className="rioglyph rioglyph-ok text-slate-700" />
                                </div>
                            </div>

                            <div className="flex-1">
                                <div className="bg-white rounded-xl border border-gray-200 p-4 sm:p-6">
                                    <div className="flex flex-col sm:flex-row sm:space-x-6">
                                        <div className="w-full">
                                            <div className="flex flex-row items-start justify-between sm:w-7/12">
                                                <div className="flex flex-row items-center">
                                                    <div className="h-20 bg-slate-200" style={{width: 0}}></div>
                                                    <div className="flex flex-col">
                                                        <span className="font-semibold  text-gray-600 ">Usuário:</span>{' '}
                                                        <span className="">{item.user}</span>
                                                    </div>
                                                </div>

                                                <div className="flex flex-row items-center gap-20">
                                                    <div className="h-20 bg-slate-200" style={{width: 1}}></div>
                                                    <div className="flex flex-col">
                                                        <span className="font-semibold text-gray-600">Data/Hora:</span>{' '}
                                                        <span className="font-medium ">{item.dateTime}</span>
                                                    </div>
                                                </div>

                                                <div className="flex flex-row items-center gap-20">
                                                    <div className="h-20 bg-slate-200" style={{width: 1}}></div>
                                                    <div className="flex flex-col">
                                                        <span className="font-semibold text-gray-600">Etapa:</span>{' '}
                                                        <span className="font-medium ">{item.stage}</span>
                                                    </div>
                                                </div>

                                                <div className="flex flex-row items-center gap-20">
                                                    <div className="h-20 bg-slate-200" style={{width: 1}}></div>
                                                    <div className="flex flex-col">
                                                        <span className="font-semibold text-gray-600">Campo alterado:</span>{' '}
                                                    <span className="font-medium ">{item.fieldChanged}</span>
                                                    </div>
                                                </div>

                                            </div>


                                            <div className="flex gap-20 mt-5">
                                                <div>
                                                    <div className="font-semibold text-gray-600">Valor anterior:</div>
                                                    <div className="mt-2 bg-gray-50 border border-gray-100 rounded-md p-3  text-gray-600">
                                                        {item.previousValue}
                                                    </div>
                                                </div>
                                                <div className="flex flex-row items-center gap-20">
                                                    <div className="w-1 h-full bg-slate-200"></div>
                                                    <div>
                                                        <div className="font-semibold text-gray-600">Novo valor:</div>
                                                        <div className="mt-2 bg-gray-50 border border-gray-100 rounded-md p-3  text-gray-600">
                                                            {item.newValue}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}